import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Box, Card, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import EditIcon from '../images/EditIcon.png'
import { ModalDelDialog } from './ModalDelDialog'
import { ModalEditDialog } from './ModalEditDialog'

interface CustomCardProps {
  title: string
  id: string
  text: string
  file: string
  onEdit: (id: string, newText: string, file?: File) => void
  onDel: (id: string) => void
}

export const CustomCard: React.FC<CustomCardProps> = props => {
  const { title, id, text, file, onEdit, onDel } = props
  const auth = useAuth()
  const fileUrl: string = file
  const [isHovered, setIsHovered] = React.useState(false)
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [openDelDialog, setOpenDelDialog] = useState(false)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const fileInputRef = useRef<HTMLInputElement>(null)
  const videoFileRef = useRef<HTMLVideoElement>(null)
  const regexp = /(mov|.3gp|.mp4|.ts|.webm|.mkv)$/i

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      setSelectedFile(file)
    }
    // 同じファイル選択のため、初期化
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  const handleEditClick = () => {
    setOpenEditDialog(true)
  }
  const handleDeleteClick = () => {
    setOpenDelDialog(true)
  }
  const handleClose = () => {
    setOpenEditDialog(false)
    setOpenDelDialog(false)
  }
  const handleEdit = (id: string, newText: string) => {
    onEdit(id, newText)
    handleClose()
  }
  const handleDel = () => {
    onDel(id)
    handleClose()
  }
  const handleFileMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    event.currentTarget.style.cursor = 'pointer'
  }

  const handleFileMouseLeave = (event: React.MouseEvent<HTMLDivElement>) => {
    event.currentTarget.style.cursor = 'default'
  }
  const handleFileClick = () => {
    // クリック時の処理
    // ファイル選択
    fileInputRef.current?.click()
    // console.log("file click");
  }

  useEffect(() => {
    selectedFile && onEdit(id, text, selectedFile)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFile, videoFileRef])

  return (
    <>
      {openEditDialog && (
        <ModalEditDialog
          open={openEditDialog}
          title={title}
          id={id}
          text={text}
          onClose={handleClose}
          onSave={handleEdit}
        />
      )}

      {openDelDialog && (
        <ModalDelDialog
          open={openDelDialog}
          title={title}
          id={id}
          text={text}
          onClose={handleClose}
          onDel={handleDel}
        />
      )}
      <Card sx={{ height: '288px', width: '461px', borderRadius: '10px' }}>
        <Box
          sx={{
            height: '57px',
            backgroundColor: isHovered ? '#F2F2F2' : '#282828',
            display: 'flex',
            alignItems: 'center',
            px: 2, // 左右のpaddingを追加
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Tooltip title={text} enterTouchDelay={0}>
            <Typography
              sx={{
                color: isHovered ? '#282828' : '#FFFFFF',
                fontSize: '21px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '340px',
              }}
            >
              {text}
            </Typography>
          </Tooltip>
          {isHovered && (
            <>
              <IconButton
                disabled={auth.isDisable}
                onClick={handleEditClick}
                sx={{
                  marginLeft: 'auto', // 右側に移動
                }}
              >
                <img src={EditIcon} width="25px" height="25px" alt="" />
              </IconButton>
              <IconButton
                disabled={auth.isDisable}
                onClick={handleDeleteClick}
                sx={{
                  color: 'red',
                  '& .MuiSvgIcon-root': {
                    fontSize: '40px',
                  },
                }}
              >
                <HighlightOffIcon />
              </IconButton>
            </>
          )}
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '231px',
            width: '100%',
            backgroundColor: '#F2F2F2',
          }}
          onClick={handleFileClick}
          onMouseEnter={handleFileMouseEnter}
          onMouseLeave={handleFileMouseLeave}
        >
          {regexp.test(fileUrl.split('?')[0]) ? (
            <video
              controls
              src={fileUrl}
              ref={videoFileRef}
              style={{
                maxWidth: '244px',
                maxHeight: '183px',
                objectFit: 'cover',
              }}
            />
          ) : (
            <img
              src={fileUrl}
              alt={text}
              style={{
                maxWidth: '244px',
                maxHeight: '183px',
                objectFit: 'cover',
              }}
            />
          )}
          <input
            disabled={auth.isDisable}
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept=".jpg, .jpeg, .png, .mp4, .JPG, .JPEG, .PNG, .MP4"
            onChange={handleFileChange}
          />
        </Box>
      </Card>
    </>
  )
}
